import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { Typography, Paper, Divider } from "@mui/material";
import '../../styles/partCreation.css'

const SubstitutionData = ({ checkTableData, maxRows, columnValues, subStituLoading }) => {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            color: "#000000",
            fontSize: "14px",
            fontWeight: "700",
            fontFamily: "Verdana",
            padding: "32px 20px",
            position: "sticky",
            top: 0,
            zIndex: 2,
            minWidth: "150px",
            textAlign: "center",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            position: "sticky",
            top: 0,
            zIndex: 2
        },
    }));

    const StyledTable = styled(Table)({
      
    });

    const filteredColumns = [
        "Material Number",
        "Description",
        "Vendor Name",
        "Material Group",
        "Plant Name",
        "Storage Location"
    ];
    
    const [tableData, setTableData] = useState([])
   
    useEffect(()=> {
        if (checkTableData?.length === 1 && 'Remarks' in checkTableData[0]) {
            setTableData([])
        } else {
            setTableData(checkTableData)
        }
    }, [checkTableData])

    function highlightSubstring(text) {
        return <div dangerouslySetInnerHTML={{ __html: text }} />;
    }

    return (
        <>
            <Paper sx={{
                width: "100%",
                margin: "20px 0px",
                padding: "20px",
                borderRadius: "18px"
            }} elevation={2}>
                {subStituLoading ? (
                    <>
                        <Typography>loading...</Typography>
                    </>
                ) : (<>
                   {tableData && tableData?.length > 0 ? (
                        <>
                            <Paper sx={{ width: "100%", mb: 2, }} elevation={2}>
                                <TableContainer
                                    sx={{
                                        maxHeight: "600px",
                                        overflowY: "auto",
                                    }}
                                >
                                    <StyledTable
                                        sx={{ minWidth: 750 }}
                                        aria-labelledby="tableTitle"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {filteredColumns.map((columnName) => (
                                                    <StyledTableCell
                                                        key={columnName}
                                                        align="left"
                                                        padding="normal"
                                                        sx={{
                                                            backgroundColor: "#FAF0F0 !important",
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 3,
                                                            color: "#000000",
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            fontFamily: "Verdana",
                                                        }}
                                                    >
                                                        {columnName}
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableData?.map((row, rowIndex) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row[filteredColumns[0]]}
                                                    >
                                                        {filteredColumns.map((columnName, colIndex) => (
                                                            <>
                                                                <TableCell
                                                                    key={columnName}
                                                                    align="left"
                                                                    sx={{
                                                                        fontFamily: "Verdana",
                                                                        textAlign: "center",
                                                                        borderBottom: "none"
                                                                    }}
                                                                >
                                                                    {highlightSubstring(row[columnName])}
                                                                </TableCell>
                                                            </>
                                                        ))}
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </StyledTable>
                                </TableContainer>
                            </Paper>
                        </>
                    ) : (
                        <>
                            <Typography
                                sx={{
                                    backgroundColor: "#FAF0F0",
                                    fontFamily: "Verdana",
                                    border: "1px solid #BDBDBD",
                                    padding: "32px 20px",
                                    textAlign: "center",
                                    color: "#2D3748",
                                    fontSize: "18px",
                                    fontWeight: "500",
                                }}
                            >
                                {" "}
                                No Substitute Part Found {" "}
                            </Typography>
                        </>
                    )}
                </>)
                }
            </Paper>

        </>
    )
}
export default SubstitutionData;